import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Table,
  Form,
  Row,
  Col,
  Dropdown,
  InputGroup,
} from "react-bootstrap";
import { FiEye, FiEdit, FiTrash2, FiSearch } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import EditInvoiceModal from "../../modals/invoices/EditInvoiceModal";
import DeleteModal from "../../modals/invoices/DeleteModal";
// import EditInvoiceModal from "../modals/EditInvoiceModal";
// import DeleteModal from "../modals/DeleteModal";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";
export default function InvoicesList() {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  // get selected date

  const [createdDate, setCreatedDate] = useState("");
  const [dueDate, setDueDate] = useState("");

  useEffect(() => {
    const created = localStorage.getItem("createdDate");
    if (created) {
      setCreatedDate(created);
    }

    const due = localStorage.getItem("dueDate");
    if (due) {
      setDueDate(due);
    }
  }, []);
  const data = [
    {
      id: "INV-1454",
      name: "Anthony Lewis",
      img: "/assets/img/users/user-32-1.jpg",
      total: "$300",
      due: "$0",
      status: "Paid",
    },
    {
      id: "INV-6571",
      name: "Brian Villalobos",
      img: "/assets/img/users/user-09.jpg",
      total: "$547",
      due: "$200",
      status: "Overdue",
    },
        {
      id: "INV-1454",
      name: "Anthony Lewis",
      img: "/assets/img/users/user-02.jpg",
      total: "$300",
      due: "$0",
      status: "Paid",
    },
    {
      id: "INV-6571",
      name: "Brian Villalobos",
      img: "/assets/img/users/user-03.jpg",
      total: "$547",
      due: "$200",
      status: "Overdue",
    },
        {
      id: "INV-1454",
      name: "Anthony Lewis",
      img: "/assets/img/users/user-06.jpg",
      total: "$300",
      due: "$0",
      status: "Paid",
    },
    {
      id: "INV-6571",
      name: "Brian Villalobos",
      img: "/assets/img/users/user-05.jpg",
      total: "$547",
      due: "$200",
      status: "Overdue",
    },
    
  ];


  const options = [
  "Today",
  "Yesterday",
  "Last 7 Days",
  "Last 30 Days",
  "This Year",
  "Next Year",
  "Custom Range",
];

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const ref = useRef();

  // close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  return (
    <Card className="p-3">
      {/* HEADER */}
      <div className="d-flex justify-content-between flex-wrap mb-3">
        <h5>
          Invoices <span className="badge bg-light text-dark">2000</span>
        </h5>

        <div className="d-flex gap-2 flex-wrap">
          <div
            className="date-input-box"
            onClick={() =>
              navigate("/date-picker", { state: { type: "created" } })
            }
          >
            <FiCalendar />
            <span>{createdDate || "Created Date"}</span>
          </div>

          <div
            className="date-input-box"
            onClick={() => navigate("/date-picker", { state: { type: "due" } })}
          >
            <FiCalendar />
            <span>{dueDate || "Due Date"}</span>
          </div>

          {/* STATUS */}
          <Dropdown>
            <Dropdown.Toggle className="date-box text-dark">
              Select Status
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {["Paid", "Overdue", "Pending", "Draft"].map((item) => (
                <Dropdown.Item key={item} className="dropdown-item-custom">
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* SORT */}
          <Dropdown>
            <Dropdown.Toggle className="date-box text-dark">
              Sort By : Last 7 Days
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item className="dropdown-item-custom">
                Last 7 Days
              </Dropdown.Item>
              <Dropdown.Item className="dropdown-item-custom">
                Created Date
              </Dropdown.Item>
              <Dropdown.Item className="dropdown-item-custom">
                Due Date
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* FILTER */}
      <div className="d-flex justify-content-between mb-2 flex-wrap">
        <div>
          Row Per Page{" "}
          <Form.Select
            value={rows}
            onChange={(e) => setRows(e.target.value)}
            className="d-inline w-auto"
          >
            {[10, 25, 50].map((n) => (
              <option key={n}>{n}</option>
            ))}
          </Form.Select>
        </div>

        <InputGroup className="w-auto">
          <InputGroup.Text>
            <FiSearch />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      </div>

      {/* TABLE */}
      <Table responsive hover>
        <thead className="table-light">
          <tr>
            <th></th>
            <th>Invoice</th>
            <th>Name</th>
            <th>Created On</th>
            <th>Total</th>
            <th>Amount Due</th>
            <th>Due Date</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {data
            .filter(
              (item) =>
                item.name.toLowerCase().includes(search.toLowerCase()) ||
                item.id.toLowerCase().includes(search.toLowerCase()),
            )
            .slice(0, rows)
            .map((item, i) => (
              <tr key={i}>
                <td>
                  <Form.Check />
                </td>

                <td className="text-dark"><Link to="/invoice-details" className="text-decoration-none text-dark" >
                {item.id}</Link></td>

                <td>
                    <Link to="/invoice-details" className="text-decoration-none text-dark" >
                   <div className="d-flex align-items-center">
                    <img
                      src={item.img}
                      className="rounded-circle me-2"
                      width={40}
                    />
                    <div>
                      <div>{item.name}</div>
                      <small>[email protected]</small>
                    </div>
                  </div></Link>
             
                </td>

                <td>14 Jan 2024</td>
                <td>{item.total}</td>
                <td>{item.due}</td>
                <td>14 Jan 2024</td>

                <td>
                  <span className={`badge ${getStatusClass(item.status)}`}>
                    {item.status}
                  </span>
                </td>

                <td>
                  <div className="d-flex gap-2">
                    <FiEye
                      className="icon"
                      onClick={() => navigate("/invoice-details")}
                    />
                    <FiEdit
                      className="icon"
                      onClick={() => setShowEdit(true)}
                    />
                    <FiTrash2
                      className="icon"
                      onClick={() => setShowDelete(true)}
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>


  


      </Table>

      {/* MODALS */}
      <EditInvoiceModal show={showEdit} onHide={() => setShowEdit(false)} />
      <DeleteModal show={showDelete} onHide={() => setShowDelete(false)} />

      {/* STYLE */}
      <style>{`
        .btn-white {
          background: #fff;
          border: 1px solid #ddd;
        }

        .dropdown-item-custom:hover {
          background: #ff6a00;
          color: #fff;
        }

        .icon {
          cursor: pointer;
        }

        
/* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}
.date-input-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  min-width: 180px;
  background: #fff;
}

.date-input-box:hover {
  border-color: #ff6a00;
}

.date-input-box svg {
  color: #999;
}
/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}
/* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}

        .custom-input:focus {
          border-color: #ff6a00;
          box-shadow: 0 0 0 0.2rem rgba(255,106,0,0.2);
        }

        .badge-success { background: #e6f7ee; color: green; }
        .badge-danger { background: #fdeaea; color: red; }
        .badge-warning { background: #fff4e5; color: orange; }
        .badge-purple { background: #f3e8ff; color: purple; }

        @media(max-width:768px){
          .d-flex { flex-direction: column !important; }
        }
      `}</style>
    </Card>
  );
}

// STATUS COLOR
function getStatusClass(status) {
  switch (status) {
    case "Paid":
      return "badge-success";
    case "Overdue":
      return "badge-danger";
    case "Pending":
      return "badge-purple";
    default:
      return "badge-warning";
  }
}
